// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee74e81d","732":"c09587ab","977":"5b0c617d"}[chunkId] + ".chunk.js";
};